export default "__VITE_ASSET__Dn5YTnzu__"